import type { InFieldCDMLocationConfig } from '../../cdm-types';
import type { LocationOption } from '../types';

export const mapLocationConfigToOption = (
  locationConfig: InFieldCDMLocationConfig
): LocationOption => {
  const name = locationConfig.name ?? locationConfig.externalId;
  return {
    label: name,
    value: {
      externalId: locationConfig.externalId,
      name,
      space: locationConfig.space,
      assetExternalId: undefined,
    },
  };
};
